import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { LoggerService } from '../../logger';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private logger: LoggerService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.logger.debug('AuthGuard', 'canActivate')();
    return this.auth.isLoggedIn$.pipe(
      tap((loggedIn) => {
        this.logger.debug(
          'AuthGuard',
          'canActivate.auth.isLoggedIn',
          loggedIn
        )();
        if (!loggedIn) {
          this.auth.startAuthentication(state.url);
        }
      })
    );
  }
}
